// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-tooltip__content[data-v-265e1bca]{color:#666;background-color:var(--v-surface-lighten5);border:1px solid #666}", ""]);
// Exports
module.exports = exports;
